// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__35VjP","buttons":"Footer_buttons__1IaBX"};